var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47108 5.5312C4.21073 5.27085 3.78862 5.27085 3.52827 5.5312C3.26792 5.79155 3.26792 6.21366 3.52827 6.47401L7.52827 10.474C7.78862 10.7344 8.21073 10.7344 8.47108 10.474L12.4711 6.47401C12.7314 6.21366 12.7314 5.79155 12.4711 5.5312C12.2107 5.27085 11.7886 5.27085 11.5283 5.5312L7.99967 9.0598L4.47108 5.5312Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrown);
export default __webpack_public_path__ + "static/media/downArrown.ddf43d48f674f7a7f9755230e19928c6.svg";
export { ForwardRef as ReactComponent };